export default __webpack_public_path__ + "e1fb541994eba9929e52db0f3cb6b8ab.png";